
/*
 * Não há problemas guardar esses dados aqui, pois apenas encripta
 * para ofuscar o valor do localStorage.
 */
const CHAVE_FIXA_STRING = "cMzabWMyTeEvBEeZbo2XYXSILb0EZb6y";
const IV_FIXO_STRING = "uyhBwwImA4if";

export const getUsuarioPadrao = () => {
  return {
    usuario_uuid: '',
    usuario_email: '',
    usuario_nome: '',
    usuario_ativo: false,
    usuario_nome_social: '',
    usuario_administrador: false,
    perfil_uuid: '',
    perfil_nome: '',
    session_uuid: '',
    session_logado: false,
    escritorio_uuid: '',
    escritorio_nome: '',
    escritorio_ativo: false,
    timestamp: '',
  };
};

/**
 * Função interna auxiliar para converter a string da chave em um objeto nativo do navegador.
 * Como o 'importKey' retorna uma Promise, usamos .then() em vez de await.
 */
function obterChaveNativa(callbackSucesso, callbackErro) {
    const encoder = new TextEncoder();
    const chaveBytes = encoder.encode(CHAVE_FIXA_STRING);

    window.crypto.subtle.importKey(
        "raw",
        chaveBytes,
        { name: "AES-GCM" },
        false,
        ["encrypt", "decrypt"]
    ).then(callbackSucesso).catch(callbackErro);
}

/**
 * Criptografa um objeto JSON e devolve o resultado via Callback
 */
function criptografarJson(objeto, callbackResultado) {
    const encoder = new TextEncoder();
    const ivBytes = encoder.encode(IV_FIXO_STRING);
    const dadosBytes = encoder.encode(JSON.stringify(objeto));

    // Busca a chave nativa e encadeia a criptografia usando Promises nativas
    obterChaveNativa(function(chaveNativa) {
        window.crypto.subtle.encrypt(
            { name: "AES-GCM", iv: ivBytes },
            chaveNativa,
            dadosBytes
        ).then(function(cifradoBuffer) {
            // Transforma o ArrayBuffer binário para string Base64 para envio/armazenamento
            const base64 = btoa(String.fromCharCode(...new Uint8Array(cifradoBuffer)));
            callbackResultado(null, base64); // Sucesso: primeiro parâmetro é null (padrão Node/JS)
        }).catch(function(erro) {
            callbackResultado(erro, null);
        });
    }, function(erroChave) {
        callbackResultado(erroChave, null);
    });
}

/**
 * Descriptografa a string Base64 e devolve o objeto JSON original via Callback
 */
function descriptografarJson(textoBase64, callbackResultado) {
    const encoder = new TextEncoder();
    const decoder = new TextDecoder();
    const ivBytes = encoder.encode(IV_FIXO_STRING);

    // Converte a string Base64 de volta para array de Bytes (Uint8Array)
    const dadosCifrados = new Uint8Array(
        atob(textoBase64).split("").map(function(c) { return c.charCodeAt(0); })
    );

    obterChaveNativa(function(chaveNativa) {
        window.crypto.subtle.decrypt(
            { name: "AES-GCM", iv: ivBytes },
            chaveNativa,
            dadosCifrados
        ).then(function(decodificadoBuffer) {
            const jsonObjeto = JSON.parse(decoder.decode(decodificadoBuffer));
            callbackResultado(null, jsonObjeto); // Sucesso
        }).catch(function(erro) {
            callbackResultado(erro, null);
        });
    }, function(erroChave) {
        callbackResultado(erroChave, null);
    });
}

export const saveJWT = (session_token) => {
  localStorage.setItem('JWT',session_token);
}

export const getJWT = () => {
  if (!hasJWT()) {
    return '';
  } else {
    return localStorage.getItem('JWT');
  }
}

export const hasJWT = () => {
  if (localStorage.getItem('JWT') !== null) {
    return true;
  } else {
    return false;
  }
}

export const deleteJWT = () => {
  if (localStorage.getItem('JWT') !== null) {
    localStorage.removeItem('JWT');
  }
}

export const saveAuthenticated = (usuario,callback) => {
  usuario.timestamp = Date.now();

  criptografarJson(usuario,(erro,textoCriptografado)=>{
      if (erro) {
        console.error("Erro ao criptografar:", erro);
        callback();
      } else {
        localStorage.setItem('authenticated',textoCriptografado);
        callback();
      }
  });
}

export const hasAuthenticated = () => {
  if (localStorage.getItem('authenticated') !== null) {
    return true;
  } else {
    return false;
  }
}

export const getAuthenticated = (callback) => {
  if (!hasAuthenticated()) {
    callback(getUsuarioPadrao());
  } else {
    const textoCriptografado = localStorage.getItem('authenticated');
    descriptografarJson(textoCriptografado, function(erroDesc, usuario) {
        if (erroDesc) {
          console.error("Erro ao descriptografar:", erroDesc);
          callback(getUsuarioPadrao());
        } else {
          callback(usuario);
        }
    });
  }
}

export const getUserData = (callback) => {
  getAuthenticated((usuario)=>{
    const root = (usuario.usuario_email === 'lgapontes@gmail.com');
    callback(usuario.usuario_administrador,root,usuario.escritorio_uuid,usuario.usuario_uuid);
  });
};

export const deleteAuthenticated = () => {
  if (localStorage.getItem('authenticated') !== null) {
    localStorage.removeItem('authenticated');
  }
}

export const deleteStorage = () => {
  deleteAuthenticated();
  deleteJWT();
}
